import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dashboard" }

import TileProjectDashboardBudgetThemes from "@/components/TileProjectDashboardBudgetThemes.vue";
import TileProjectDashboardTasks from "@/components/TileProjectDashboardTasks.vue";
import TileProjectDashboardPhases from "@/components/TileProjectDashboardPhases.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectDashboard',
  props: {
    id: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TileProjectDashboardBudgetThemes, { id: __props.id }, null, 8, ["id"]),
    _createVNode(TileProjectDashboardTasks, { id: __props.id }, null, 8, ["id"]),
    _createVNode(TileProjectDashboardPhases, {
      id: __props.id,
      class: "tile-phase"
    }, null, 8, ["id"])
  ]))
}
}

})